/** saves Customer Info
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customers
*/
export const SAVE_CUSTOMER_INFO = (state, payload) => {
    state.customerInfo = payload
    state.customerContactsInfo = payload.personalData.contacts
}

/** updates Customer Contact Info
@payload { string, number } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_customers
*/
export const UPDATE_DEFAULT_PHONENUMBER = (state, payload) => {
    state.customerContactsInfo = state.customerContactsInfo.map(element => {
        return { ...element, default: element.contact === payload }
    })
}
